import { enrichRegistrationFormPropsMsdTypeAll } from "./msdTypeAll";
export var enrichRegistrationFormPropsMsdTypeAllAndEpisodes = function () {
    return enrichRegistrationFormPropsMsdTypeAll({ showEpisodesSelect: true });
};
